export default __webpack_public_path__ + "static/media/tick-circle.680db196.svg";